import axios from 'axios';
import { API_URL, HOST_NAME, API_TOKEN, ROOT_ROUTE } from '../../constants';
import {formatDate, formatTime, transliterator} from '../../helpers/utils';
import {getImagePath} from '../../helpers'
export const fetchCities =  async (filter) => {
    const urlCounties = `${API_URL}/utility/?do=notemptycounties`;
    let params = '';
    if(filter) {
        params = filter.where ? `&${filter.where}`:params;
        params = filter.kind ? `${params}&${filter.kind}`:params;
        params = filter.date ? `${params}&${filter.date}`:params;
    }

    try {
        const response = await axios.get(`${urlCounties}${params}`);
        const { data } = response;
        const list = composeList(data);
        return list
   } catch(err) {
        return []
   }
}

export const fetchTotal =  async () => {
    const urlTotal = `${API_URL}/api/?do=totalevents&token=${API_TOKEN}&lang=nat&format=json`;
    try {
        const response = await axios.get(urlTotal);
        if (response.data && response.data.code === 1) {
            const { data:{data:{totalevents}}} = response;
            return totalevents;
        } else {
            return 0;
        }
   } catch(err) {
        return 0;
   }
}

export const fetchBanners = async () => {
    const bannersUrl = `${API_URL}/api/?do=banners&token=${API_TOKEN}&lang=nat&format=json&active=true`;
    try {
        const response = await axios.get(bannersUrl);
        //console.log(response);

        if (response.data && response.data.code === 1) {

            //console.log(response);
            const { data:{data:{banners}}} = response;

            return banners;
        } else {
            return 0;
        }
    } catch(err) {
        return 0;
    }
}

export const fetchCategories =  async (filter) => {
    const urlCats = `${API_URL}/api/?do=categories&token=${API_TOKEN}&lang=nat&format=json`;

    try {
        const response = await axios.get(urlCats);
        const { data } = response;
        return data
   } catch(err) {
        return []
   }
}


export const getEvents = async (filter, noGroup=false) => {
    const filterWhere = filter.where ? `&${filter.where}` : '';
    const filterCategory = filter.kind ? `&${filter.kind}` : '';
    const filterDate = filter.date ? `&${filter.date}` : '';
    const filterKeyword = filter.keyword ? `&${filter.keyword}` : '';
    if (!filter.where && !filter.kind && !filter.date && !filter.keyword) {
        return {total:0, events:[]}
    }
    let url = `${API_URL}/api/?do=events&token=${API_TOKEN}&lang=nat${filterWhere}${filterCategory}${filterDate}${filterKeyword}&order=starta&start=${filter.start}&limit=${filter.limit}&format=json&showall=false&alltimes=true&ignoremuuseums=true`;
    const response = await axios.get(url);
    const {data:{data}} = response
    let events = data
    if (!noGroup) {
        events = groupEvents(data);
    }
    if (noGroup) {
        events = groupPromotedEvents(data);
    }

    return {total: data ? data.total : 0, events} || {total:0, events:[]}
}

export const getRecent = async (start = 0, limit=10) => {
    let url = `${API_URL}/api/?do=events&token=${API_TOKEN}&lang=nat&order=created&start=${start}&limit=${limit}&format=json&showall=false&alltimes=true&ignoremuuseums=true`;
    const response = await axios.get(url);
    const {data:{data}} = response
    //const events = groupEvents(data);
    return {total: data ? data.total : 0, events: data ? data.events : []}
}

export const getPromoted = async () => {
    const promoFilter  = '&promotion=28047';
    let url = `${API_URL}/api/?do=events&token=${API_TOKEN}&lang=nat${promoFilter}&order=starta&format=json&alltimes=true`;
    const response = await axios.get(url);
    const {data:{data}} = response
    const events = groupPromotedEvents(data)

    return {total:events.length, events} || {total:null, events:[]}
}

const groupPromotedEvents = (data) => {
    if (!data) {
        return [];
    }
    const result = [];
    data.events.forEach((ev) => {
        if (!result.find( e => e.id === ev.id )) {
            const promoObject = {
                id: ev.id,
                name: ev.name,
                place_name: ev.place_name,
                period: getStartEnd(ev.times),
                hasimage: ev.hasimage,
                image: getImagePath(ev.image),
                url: makeurl(ev.url),
            }
            result.push(promoObject);
        }
    });
    //console.log(result)
    return result;
}

const makeurl = (url) => {

    if (process.env.REACT_APP_STAGE_ENV === 'stage') {
        const result = url.replace(HOST_NAME, '/kava-front').replace('/event/','/event-new/');
        return result
    }

    if (process.env.NODE_ENV === 'production') {
        const rootSubst = ROOT_ROUTE && ROOT_ROUTE !== '/' ? '/kava-front' : ''
       // console.log(url.replace(HOST_NAME, rootSubst))
        const result = url.replace('http://','https://').replace(HOST_NAME, rootSubst).replace('/event-new/','/event/');
        return result
    }

    return url.replace(HOST_NAME, '/kava-front').replace('/event/','/event-new/');
}

const getStartEnd = (times) => {
    if (times.length === 1) {
        return { start: `${formatDate(times[0].start_time, 'd.M')} ${formatTime(times[0].start_time)}`, end: null};
    }
    times.sort((a,b) => {
        if (a.start_time > b.start_time) {
            return 1;
        }
        if (a.start_time < b.start_time) {
            return -1;
        }
        return 0;
    })

    return { start: formatDate(times[0].start_time, 'dd.mm.yyyy'), end: formatDate(times[times.length-1].start_time, 'dd.mm.yyyy')};
}

export const getSingleEvent = async (internalUrl) => {
    if (!internalUrl) {
        return null;
    }
    const filterEvent = `&url=${internalUrl}`;
    // /api/?do=getbyurl&token=${API_TOKEN}&lang=nat&url=viru-varietee-2020&start=0&limit=1&format=json&type=event
    let url = `${API_URL}/api/?do=getbyurl&token=${API_TOKEN}&lang=nat${filterEvent}&start=0&limit=1&format=json&type=event`;
    const options = {
        method: 'get',
        url,
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true
    }
    //const response = await axios.get(url);
    const response = await axios(options);
//    console.log(response.data)
    const {data:{data:{content}}} = response

    return content || null
}

const groupEvents = (data) => {
    const groupedEvents = [];
    const dateArray = [];
    if(!data || !data.events) {
        return [];
    }

    data.events.forEach(event => {
        if (event.city.toLowerCase() === 'muu' || !event.county) {
            if (!event.categories.includes(14452)) {
                return
            }
        }

        const formatted = formatDate(event.start_time, 'w.d.M');

        if (dateArray.includes(formatted)) {
            const group = groupedEvents.find(g => g.date === formatted);
            if (group) {
                group.events.push(event);
            } else {
                const newGroup = {
                    date: formatted,
                    sortKey:event.start_time,
                    events: [event],
                };
                groupedEvents.push(newGroup);
            }
        } else {
            dateArray.push(formatted);
            const newGroup = {
                date: formatted,
                sortKey:event.start_time,
                events: [event],
            };
            groupedEvents.push(newGroup);
        }
    })
    groupedEvents.sort((a, b) => {
        if (a.sortKey > b.sortKey) return 1;
        if (a.sortKey < b.sortKey) return -1;
        return 0;
    })
    return groupedEvents;
}

const composeList = (response) => {
    const { code, data } = response;
    if (code !== 1) return null;
    let currentCounty = null;
    let result = [];
    let tallinn = []
    data.forEach(row => {
        if (currentCounty !== row.county_internalurl) {
            currentCounty = row.county_internalurl
            if (row.county_internalurl === 'tallinn') {
                tallinn.push({id: row.county_internalurl, name: row.co_name, className: 'county county-header', parent: currentCounty});
            } else {
                const countyName = row.co_name.toUpperCase() !== 'SAAREMAA'? row.co_name.replace('maa',''):row.co_name;

                result.push({id: row.county_internalurl, name: countyName, className: 'county county-header',parent: currentCounty});
            }

        }
        if (row.county_internalurl === 'tallinn') {
            tallinn.push({id: row.city_internalurl, name: row.city_name, parent: currentCounty});
        } else {
            if (row.city_internalurl !== 'muu') {
                result.push({id: row.city_internalurl, name: row.city_name, parent: currentCounty});
            }
        }

    })
    return [...tallinn, ...result];
}


export const fetchPlace = async (internalUrl) => {
    const filter = `&url=${internalUrl}`;
    let url = `${API_URL}/api/?do=getbyurl&token=${API_TOKEN}&lang=nat${filter}&format=json&type=place`;
    const response = await axios.get(url);
//    console.log(response.data)
    const {data:{data:{content}}} = response

    return content || null
}


export const sendLogin = async (data) => {
    let url = `${API_URL}/auth/?do=login`;
    const formData = new FormData();
    formData.append('username', data.username);
    formData.append('password', data.password);
    const options = {
        withCredentials: true,
        method: 'post',
        url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data' }
    }
    const response = await axios(options);

    if (response.data && response.data.code === -1) {
        return false
    }

    return true
}

export const sendFbLogin = async (data) => {
    const at= data.accessToken;
    const url = `${API_URL}/auth/?do=js_fb_login&at=${at}`
    const options = {
        withCredentials: true,
        method: 'post',
        url,
        headers: {'Content-Type': 'multipart/form-data' }
    }
    const response = await axios(options);

    if (response.data && response.data.code === -1) {
        return false
    }
    return true
}

export const requestResetLink = async (data) => {
    let url = `${API_URL}/auth/?do=passremind`;
    const formData = new FormData();
    formData.append('email', data.email);
    const options = {
        method: 'post',
        url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data' }
    }
    const response = await axios(options);

    if (response.data && response.data.code === -1) {
        return false
    }

    return true
}

export const resetPasswords = async (data) => {
    let url = `${API_URL}/myprofile/?do=changepassword`;
    const formData = new FormData();
    formData.append('password', data.password);
    formData.append('password2', data.password);
    const options = {
        method: 'post',
        url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data' }
    }
    const response = await axios(options);

    if (response.data && response.data.code === -1) {
        return false
    }
    return true
}

export const userRegister = async (data) => {
    try {
        let url = `${API_URL}/auth/?do=register`;
        const formData = new FormData();
        formData.append('username', data.username);
        formData.append('password', data.password);
        formData.append('password2', data.password);
        formData.append('firstname', data.username.split(' ')[0]);
        formData.append('lastname', data.username.split(' ')[1] || data.username.split(' ')[0]);
        formData.append('email', data.email);
        //formData.append('phone', data.phone);

        const options = {
            method: 'post',
            url,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data' },
            // withCredentials: true
        }
        const response = await axios(options);

        return response.data
    } catch (err) {
        return { code: -1, message: err.message }
    }

}

export const getProfile =async  () => {
    let url = `${API_URL}/api/?do=getprofile&token=${API_TOKEN}&lang=nat&format=json`;
    const options = {
        method: 'get',
        url,
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true
    }

    const response = await axios(options);
    return response.data;
}

export const doLogout = async () => {
    let url = `${API_URL}/auth/?do=logout`;
    const options = {
        withCredentials: true
    }
    await axios.get(url, options);
    return true;
}

export const requestStaticPage = async (pageUrl) => {
    let url = `${API_URL}/page/?do=getpage`;
    const formData = new FormData();
    formData.append('internalurl', pageUrl);
    const options = {
        withCredentials: true,
        method: 'post',
        url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data' }
    }
    const response = await axios(options);
    return response.data.data.page;
}


export const requestPiletiLeviTop = async () => {
    let url = `${API_URL}/api/?do=top10&token=${API_TOKEN}&lang=nat&format=json`;
    const options = {
        method: 'get',
        url,
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true
    }

    const response = await axios(options);
    return response.data;
}

export * from './ajax';
